import { TextButton } from "../components/atoms";
import { rememberMeRouteIdKey } from "../providers/authentication/RememberMeRouteIdKey";

export function Unauthorized() {
  return (
    <div className="bg-primary-50 flex h-screen w-full justify-center">
      <div className="mt-24 w-[420px]">
        <div className="bg-gymflow-logo m-8 h-12 bg-contain bg-center bg-no-repeat" />
        <div className="mt-5 text-center">
          You are not authorized to access this club. Make sure you are
          selecting the right club at login.
        </div>
        <div className="mt-5 flex justify-center">
          <TextButton
            onClick={() => {
              localStorage.removeItem(rememberMeRouteIdKey);
              // eslint-disable-next-line react-compiler/react-compiler
              window.location.href = "/";
            }}
          >
            Back to login
          </TextButton>
        </div>
      </div>
    </div>
  );
}
